import { render, staticRenderFns } from "./CartaoDeDatas.vue?vue&type=template&id=03b85d26&scoped=true"
import script from "./CartaoDeDatas.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeDatas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeDatas.vue?vue&type=style&index=0&id=03b85d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b85d26",
  null
  
)

export default component.exports